import { render, staticRenderFns } from "./PreguntasExportar.vue?vue&type=template&id=23fca6f9"
import script from "./PreguntasExportar.vue?vue&type=script&lang=js"
export * from "./PreguntasExportar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports